import { useCallback, useEffect, useState } from "react";
import { VenueSeatAvailabilityReportModel } from "../models/venue-seat-availability-report-model";
import { getEventDateAvailableSeatsReport, getPackageAvailableSeatsReport } from "../venue-plans";

type UseSeatsAvailabilityRequest = {
    eventDateId?: number;

    packageId?: number;
    packageSelectedDateIds?: number[];
}

export function useSeatsAvailability(req: UseSeatsAvailabilityRequest): [ VenueSeatAvailabilityReportModel, boolean, (() => void) ] {
    const [processing, setProcessing] = useState(true);
    const [result, setResult] = useState<VenueSeatAvailabilityReportModel>(null);

    const refresh = useCallback(() => {
        if(req.eventDateId || req.packageId) {
            setProcessing(true);

            const fetchSeatStatus = async () => {
                try {
                    let seatReport: VenueSeatAvailabilityReportModel = null;
                    if(req.packageId) // If multi date package
                        seatReport = await getPackageAvailableSeatsReport(tsapp.getRESTAPIThroughLegacyUrl(), req.packageId, req.eventDateId, req.packageSelectedDateIds);
                    else if(req.eventDateId) // If regular event
                        seatReport = await getEventDateAvailableSeatsReport(tsapp.getRESTAPIThroughLegacyUrl(), req.eventDateId);
                    
                    setResult(seatReport);
                    setProcessing(false);
                } catch { // Returns not found when the availability report isn't available
                    setResult(null);
                    setProcessing(false);
                }
            };
            
            fetchSeatStatus();
        } else {
            setProcessing(false);
            setResult(null);
        }
    }, [req.eventDateId, req.packageId, req.packageSelectedDateIds]);

    useEffect(() => {
        refresh();
    }, [req.eventDateId, req.packageId, req.packageSelectedDateIds, refresh]);

    return [ result, processing, refresh ];
}